import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CourseDto } from '@app/store/shared/models';
import { PaginatedDto, PaginationParamsDto } from '../models';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getCourses(value: PaginationParams): Observable<PaginatedDto> {
        return this.httpClient
            .get<CourseDto[]>('courses', {
                params: new PaginationParamsDto(value).params,
                observe: 'response',
            })
            .pipe(map((response) => new PaginatedDto(response)));
    }
}
